import { render, staticRenderFns } from "./TableForFAIBlock.vue?vue&type=template&id=7848494e&scoped=true&"
import script from "./TableForFAIBlock.vue?vue&type=script&lang=js&"
export * from "./TableForFAIBlock.vue?vue&type=script&lang=js&"
import style0 from "./TableForFAIBlock.vue?vue&type=style&index=0&id=7848494e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7848494e",
  null
  
)

export default component.exports